import { Immutable } from "immer";
import React from "react";

import { Context, templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: Immutable<templates.NavIFrameDocumentTemplate>,
): React.JSX.Element => {
    const staticBase = React.useContext(Context).chrome.static_base;
    return (
        <PageSkeleton
            pageChrome={props.page_chrome}
            showFooter={false}
            wrapMain={false}
            bareChrome={true}
        >
            {/* iFrameResizer config must be set before the contentWindow script loads. */}
            <script
                dangerouslySetInnerHTML={{
                    __html: `window.iFrameResizer = { heightCalculationMethod: "lowestElement" };`,
                }}
            />
            <script
                src={`${staticBase}dist2/iframe-resizer/iframeResizer.contentWindow.js`}
            />
        </PageSkeleton>
    );
};
